import mainImg from "../../../assets/ms-2d-hydraulick-hinge.jpeg"; 


import thumb1 from "../../../assets/ms-2d-hydraulick-hinge-thumnail.png";
import thumb2 from "../../../assets/ms-2d-hydraulick-hinge-thumnail-two.png";

import mainImgOne from "../../../assets/165-corner-hinges.webp"; 
import thumb3 from "../../../assets/165-thumb-one-3d.png"; 
import thumb4 from "../../../assets/165-thumb-two.png"; 


import mainImgTwo from "../../../assets/five-hole-ss 3d-hydraulic-hing.webp";
import thumb5 from "../../../assets/five-hole-ss 3d-hydraulic-hinge-thumb-two.webp";
import thumb6 from "../../../assets/five-hole-ss 3d-hydraulic-thumb-one.webp";

import maimImgThree from "../../../assets/three-hole-black-coated-3d-hydraulic-hinge.png"; 
import thumb7 from "../../../assets/three-hole-black-coated-3d-hydraulic-hinge-thumb-one.webp";
import thumb8 from "../../../assets/three-hole-black-coated-3d-hydraulic-hinge-thumb-two.webp";


import   maimImgfour from "../../../assets/three-hole-ms-3d-hydraulic-hinge.webp";
import   thumb9 from "../../../assets/three-hole-ms-3d-hydraulic-hinge-thumb-one.webp";
import   thumb10 from "../../../assets/three-hole-ms-3d-hydraulic-hinge-thumb-two.webp";
 
import mainImage5 from "../../../assets/push-opne-hinges.webp";
 import thumb11 from "../../../assets/push-opne-hinges-thumb-two.webp";
 import thumb12 from "../../../assets/push-opne-hinge-thumb-one.webp";


import mainImg6 from "../../../assets/ss-short-arm-hydraulic-hinge.webp";
 import thumb13 from "../../../assets/ss-short-arm-hydraulic-hinges-thumb-two.webp";
  import thumb14 from "../../../assets/ss-short-arm-hydraulic-hinges-thumb-one.webp";



import mainImg7 from "../../../assets/profile-hinges.webp";
import thumb15 from "../../../assets/profile-hinges-thumb-one.webp";
import thumb16 from "../../../assets/profile-hinges-thumb-two.webp";


import mainImg8 from "../../../assets/ms-short-arm hydraulic-hinge.png";
import thumb17 from "../../../assets/ms-short-arm hydraulic-hinge-thumb-one.png";
import thumb18 from "../../../assets/ms-short-arm hydraulic-hinge-thumb-two.png";

import mainImg9 from "../../../assets/3d-thick-door-cabinet-hinges.webp";
import thumb19 from "../../../assets/3d-thick-door-cabinet-hinges-thumb-one.webp";
import thumb20 from "../../../assets/3d-thick-door-cabinet-hinges-thumb-two.webp";

import mainImg10 from "../../../assets/90-dgree-blind-corner-hinge.webp";
import thumb21 from "../../../assets/90-dgree-blind-corner-hinge-thumb-one.webp";
import thumb22 from "../../../assets/90-dgree-blind-corner-hinge-thumb-two.webp";

import mainImg11 from "../../../assets/five-hole-ms-3d-hydraulic-hinges.png";
import thumb24 from "../../../assets/five-hole-ms-3d-hydraulic-hinges-thumb-one.png";
import thumb23 from "../../../assets/five-hole-ms-3d-hydraulic-hinges-thumb-two.webp";

import mainImg12 from "../../../assets/small-angle-4d-hydraulic-hinge.webp";
import thumb25 from "../../../assets/small-angle-4d-hydraulic-hinge-thumb-one.webp";
import thumb26 from "../../../assets/small-angle-4d-hydraulic-hinge-thumb-two.webp";

import mainImg13 from "../../../assets/full-ss-hinge.webp";
import thumb27 from "../../../assets/full-ss-hinge-thumb-two.webp";
import thumb28 from "../../../assets/full-ss-hinge-thumb-one.webp";

import mainImg14 from "../../../assets/sus-304.png";
import thumb29 from "../../../assets/sus-304-thumb-one.png";
import thumb30 from "../../../assets/sus-304-thumb-two.png";

import mainImg15 from "../../../assets/4-inch-frog-hinge.webp";
import thumb31 from "../../../assets/4-inch-frog-hinge-thumb-two.webp";
import thumb32 from "../../../assets/4-inch-frog-hinge-thumb-one.webp";

import mainImg16 from "../../../assets/3-inch-non-hydraulic-hinge.webp";
import thumb33 from "../../../assets/3-inch-non-hydraulic-hinge-thumb-two.webp";
import thumb34 from "../../../assets/3-inch-non-hydraulic-hinge-thumb-one.webp";

import  mainImg17 from "../../../assets/air-hinges.png";
import thumb35 from "../../../assets/air-hinges.png";
import thumb36 from "../../../assets/air-hinges.png";

import mainImg18 from "../../../assets/glass-door-hinge.webp";
import thumb37 from "../../../assets/glass-door-hinge-thumb-one.webp";
import thumb38 from "../../../assets/glass-door-hinge-thumb-two.webp";

import mainImg19 from "../../../assets/ss-2d-hydraulic-hinge.webp";
import thumb39 from "../../../assets/ss-2d-hydraulic-hinge-thumb-two.webp";
import thumb40 from "../../../assets/ss-2d-hydraulic-hinge-thum-one.webp";

import mainImg20 from "../../../assets/five-hole-black-3d-hydraulick-hinges.webp";
import thumb41 from "../../../assets/five-hole-black-3d-hydraulick-hinges-thumb-one.webp";

import thumb42 from "../../../assets/five-hole-black-3d-hydraulick-hinges-thumb-two.png";


import  mainImg21 from "../../../assets/3d-ss-thick-door-cabinet-hinges.webp";
import thumb43 from "../../../assets/3d-ss-thick-door-cabinet-hinges.webp";
import thumb44 from "../../../assets/3d-ss-thick-door-cabinet-hinges.webp";

import  mainImg22 from "../../../assets/butt-hinges.jpeg";
import thumb45 from "../../../assets/butt-hinges.jpeg";
import thumb46 from "../../../assets/butt-hinges.jpeg";


// import  mainImg23 from "../../../assets/door-closer.png";
// import thumb47 from "../../../assets/door-closer-thub-one.png";
// import thumb48 from "../../../assets/door-closer-thumb-two.png";



export const products = [
  
{
  code: "7045",
  name: "MS 2D HYDRAULIC SOFT CLOSE HINGE",
  category: "cabinet-hinges",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  // ✅ PRICE (optional add kiya)
  price: "₹137",
  oldPrice: "₹299",
  sku: "7045",
  stock: "In Stock",

  // ✅ LINKS
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=MS 2D Hydraulic Hinge Inquiry",

  // ✅ VIDEO (optional)
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION (UPGRADED)
  short:
    "MS 2D Hydraulic Soft Close Hinge is a high-quality cabinet hinge designed for smooth, silent, and precise door operation. Made from durable mild steel, it offers excellent strength and long-lasting performance. The built-in hydraulic mechanism ensures soft closing, while the 2D adjustment feature allows easy alignment of cabinet doors. Perfect for modular kitchens, wardrobes, and modern furniture applications.",

  // ✅ FEATURES (IMPROVED)
  features: [
    "High-quality mild steel (MS) construction",
    "2D adjustment for accurate door alignment",
    "Hydraulic soft-close mechanism for silent closing",
    "Strong grip and stable performance",
    "Rust-resistant and long-lasting finish",
    "Easy installation and maintenance-free use"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Mild Steel (MS)" },
    { label: "Type", value: "2D Hydraulic Hinge" },
    { label: "Closing", value: "Soft Close" },
    { label: "Usage", value: "Cabinet / Wardrobe Doors" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Hydraulic Hinge",
      code: "7045",
      size: "0°",
      finish: "MS Finish"
    },
    
    {
      item: "Hydraulic Hinge",
      code: "7046",
      size: " 8°",
      finish: "MS Finish"
    },
    
    {
      item: "Hydraulic Hinge",
      code: "7047",
      size: "15°",
      finish: "MS Finish"
    },
    
  ],

  // ✅ FAQ (REFINED)
  faq: [
    {
      question: "What is a 2D hydraulic hinge?",
      answer:
        "A 2D hydraulic hinge allows horizontal and vertical adjustment of cabinet doors while providing smooth and silent soft closing."
    },
    {
      question: "Where can MS 2D hydraulic hinges be used?",
      answer:
        "It is ideal for modular kitchens, wardrobes, cabinets, and furniture doors."
    },
    {
      question: "Does it support soft closing?",
      answer:
        "Yes, it has a built-in hydraulic mechanism for smooth and noise-free closing."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality mild steel for long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is designed for quick installation with standard fittings."
    }
  ]
},
  
  {
  code: "7767",
  name: "165° CORNER HYDRAULIC SOFT CLOSE HINGE",
  category: "cabinet-hinges",

  mainImage: mainImgOne,
  thumbnails: [thumb3, thumb4],

  // ✅ PRICE
  price: "₹391",
  oldPrice: "₹499",
  sku: "7189",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=165 Degree Corner Hinge Inquiry",

  // ✅ VIDEO (add/change if needed)
  video:"https://www.youtube.com/embed/7Kgxm1W4af8",

  // ✅ DESCRIPTION (UPGRADED)
  short:
    "165° Corner Hydraulic Soft Close Hinge is specially designed for corner cabinets where wide door opening is required. It allows doors to open up to 165°, providing maximum accessibility and convenience. Equipped with a hydraulic soft-close mechanism, it ensures smooth, silent, and controlled closing. Built from high-quality materials, this hinge delivers excellent durability, stability, and long-lasting performance, making it ideal for modular kitchens, wardrobes, and modern furniture.",

  // ✅ FEATURES (IMPROVED)
  features: [
    "165° wide opening for maximum cabinet access",
    "Hydraulic soft-close for smooth and silent closing",
    "Strong and durable construction",
    "Smooth and stable door movement",
    "Easy installation with adjustable alignment",
    "Premium finish for modern modular furniture"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel / SS Finish" },
    { label: "Opening Angle", value: "165 Degree" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Usage", value: "Corner Cabinets / Wardrobes" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Corner Hinge",
      code: "7189",
      size: "MS 2D HYDRAULIC",
      finish: "MS"
    },
    {
      item: "Corner Hinge",
      code: "7056",
      size: "NON HYDRAULIC",
      finish: "MS"
    },
    
  ],

  // ✅ FAQ (REFINED)
  faq: [
    {
      question: "What is a 165° corner hinge?",
      answer:
        "It is a specialized hinge that allows cabinet doors to open up to 165 degrees, providing wider access to corner storage areas."
    },
    {
      question: "Where is it used?",
      answer:
        "It is commonly used in modular kitchen corner cabinets, wardrobes, and furniture requiring wide door opening."
    },
    {
      question: "Does it support soft closing?",
      answer:
        "Yes, it comes with a hydraulic soft-close mechanism for smooth and silent operation."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting and reliable performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is easy to install and allows precise door alignment using adjustable screws."
    }
  ]
},

  {
  code: "7448",
  name: "FIVE HOLE SS 3D HYDRAULIC HINGE",
  category: "cabinet-hinges",

  mainImage: mainImgTwo,
  thumbnails: [thumb5, thumb6],

  // ✅ PRICE
  price: "₹194",
  oldPrice: "₹299",
  sku: "7572",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=Five Hole SS 3D Hydraulic Hinge Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION
  short:
    "The Five Hole SS 3D Hydraulic Hinge is a premium-grade stainless steel hinge designed for superior strength and precision. Featuring 3-dimensional adjustment, it allows perfect door alignment in height, depth, and side positioning. The hydraulic soft-close mechanism ensures smooth, silent, and controlled closing. With five mounting holes, it provides extra stability, making it ideal for heavy-duty cabinet doors. Its corrosion-resistant stainless steel construction ensures long-lasting durability, perfect for modular kitchens, wardrobes, and modern furniture.",

  // ✅ FEATURES
  features: [
    "3D adjustment for precise door alignment",
    "Hydraulic soft-close for smooth and silent closing",
    "Five-hole mounting for extra strength and stability",
    "Corrosion-resistant stainless steel construction",
    "Strong and durable for heavy-duty use",
    "Premium finish for modern furniture",
    "Available Codes: 7572,7573, 7574"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Stainless Steel (SS)" },
    { label: "Adjustment Type", value: "3D Adjustable" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Mounting", value: "Five Hole Fixing" },
    { label: "Usage", value: "Cabinets / Wardrobes / Modular Kitchen" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Five Hole SS 3D Hydraulic Hinges",
      code: "7572",
      size: "0°",
      finish: "SS"
    },
    {
      item: "Five Hole SS 3D Hydraulic Hinges",
      code: "7573",
      size: "8°",
      finish: "SS"
    },
    {
      item: "Five Hole SS 3D Hydraulic Hinges",
      code: "7574",
      size: "15°",
      finish: "SS"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Five Hole SS 3D Hydraulic Hinge?",
      answer:
        "It is a stainless steel hinge with five mounting holes for stronger fixing and a hydraulic soft-close mechanism for smooth and silent operation."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "3D adjustment allows door alignment in three directions – height, depth, and side-to-side – ensuring a perfect fit."
    },
    {
      question: "Where can this hinge be used?",
      answer:
        "It is ideal for modular kitchens, wardrobes, cabinets, and furniture requiring strong support and precise alignment."
    },
    {
      question: "Is it suitable for heavy doors?",
      answer:
        "Yes, the five-hole mounting design provides extra strength, making it suitable for heavy or high-use cabinet doors."
    },
    {
      question: "Is it rust-resistant?",
      answer:
        "Yes, it is made from stainless steel, offering excellent corrosion resistance and long-lasting durability."
    }
  ]
},
{
  code: "7449",
  name: "THREE HOLE BLACK COATED 3D HYDRAULIC HINGE",
  category: "cabinet-hinges",

  mainImage: maimImgThree,
  thumbnails: [thumb7, thumb8],

  // ✅ PRICE
  price: "₹174",
  oldPrice: "₹299",
  sku: "7448",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=Three Hole Black 3D Hydraulic Hinge Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION (FIXED & IMPROVED)
  short:
    "The Three Hole Black Coated 3D Hydraulic Hinge is a premium-quality hinge designed for modern modular furniture. Featuring 3-dimensional adjustment, it allows precise door alignment in height, depth, and side positioning. Its hydraulic soft-close mechanism ensures smooth, silent, and controlled closing, preventing damage to cabinets. The three-hole mounting design offers reliable strength while maintaining easy installation. Finished with a durable black coating, it provides excellent corrosion resistance along with a sleek and modern appearance, making it ideal for kitchens, wardrobes, and contemporary furniture.",

  // ✅ FEATURES (CORRECTED)
  features: [
    "3D adjustment for precise door alignment",
    "Hydraulic soft-close for smooth and silent closing",
    "Three-hole mounting for stable and secure fixing",
    "Black-coated finish for modern premium look",
    "Corrosion-resistant and durable construction",
    "Suitable for modular kitchens and wardrobes",
    "Available Codes: 7448, 7449, 7450"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Steel with Black Coating" },
    { label: "Adjustment Type", value: "3D Adjustable" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Mounting", value: "Three Hole Fixing" },
    { label: "Usage", value: "Cabinets / Wardrobes / Modular Kitchen" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Black 3D Hydraulic Hinge",
      code: "7448",
      size: "0°",
      finish: "Black"
    },
    {
      item: "Black 3D Hydraulic Hinge",
      code: "7449",
      size: "8°",
      finish: "Black"
    },

    {
      item: "Black 3D Hydraulic Hinge",
      code: "7450",
      size: "15°",
      finish: "Black"
    },
  ],

  // ✅ FAQ (REFINED)
  faq: [
    {
      question: "What is a Three Hole Black Coated 3D Hydraulic Hinge?",
      answer:
        "It is a cabinet hinge with three mounting holes and a black-coated finish, designed with a hydraulic soft-close mechanism for smooth and silent operation."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "3D adjustment allows door alignment in three directions – height, depth, and side-to-side – ensuring a perfect fit."
    },
    {
      question: "Where can this hinge be used?",
      answer:
        "It is suitable for modular kitchens, wardrobes, cabinets, and modern furniture requiring smooth and controlled closing."
    },
    {
      question: "What are the benefits of black coating?",
      answer:
        "The black coating enhances durability, provides corrosion resistance, and gives a stylish, modern look to furniture."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is easy to install and allows fine adjustment for perfect door alignment."
    }
  ]
},
  {
  code: "7450",
  name: "THREE HOLE 3D MS HYDRAULIC HINGE",
  category: "cabinet-hinges",

  mainImage: maimImgfour,
  thumbnails: [thumb9, thumb10],

  // ✅ PRICE
  price: "₹159",
  oldPrice: "₹459",
  sku: "7048",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=Three Hole 3D MS Hydraulic Hinge Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION (IMPROVED)
  short:
    "The Three Hole 3D MS Hydraulic Hinge is a strong and reliable hinge made from high-quality mild steel, designed for everyday furniture applications. It features 3-dimensional adjustment for precise door alignment in height, depth, and side positioning. The hydraulic soft-close mechanism ensures smooth, silent, and controlled closing, protecting cabinets from damage. Its three-hole mounting design provides secure fixing and stability, making it ideal for medium-weight doors. With a durable finish and easy installation, this hinge is perfect for modular kitchens, wardrobes, and modern furniture.",

  // ✅ FEATURES (REFINED)
  features: [
    "3D adjustment for accurate door alignment",
    "Hydraulic soft-close for smooth and silent closing",
    "Three-hole mounting for secure and stable fixing",
    "Mild steel construction for strength and durability",
    "Suitable for medium-weight cabinet doors",
    "Easy installation with adjustable alignment",
    "Available Codes: 7448, 7449, 7450"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Mild Steel (MS)" },
    { label: "Adjustment Type", value: "3D Adjustable" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Mounting", value: "Three Hole Fixing" },
    { label: "Usage", value: "Cabinets / Wardrobes / Modular Kitchen" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "MS 3D Hydraulic Hinge",
      code: "7048",
      size: "0°",
      finish: "MS"
    },
     {
      item: "MS 3D Hydraulic Hinge",
      code: "7049",
      size: "8°",
      finish: "MS"
    },
     {
      item: "MS 3D Hydraulic Hinge",
      code: "7050",
      size: "15°",
      finish: "MS"
    },
  ],

  // ✅ FAQ (REFINED)
  faq: [
    {
      question: "What is a Three Hole 3D MS Hydraulic Hinge?",
      answer:
        "It is a mild steel cabinet hinge with three mounting holes and a hydraulic soft-close mechanism for smooth and silent operation."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "3D adjustment allows door alignment in three directions – height, depth, and side-to-side – ensuring a perfect fit."
    },
    {
      question: "Where can this hinge be used?",
      answer:
        "It is ideal for modular kitchens, wardrobes, cabinets, and furniture requiring smooth and controlled closing."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, the mild steel construction provides strong support and long-lasting durability for everyday use."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it is easy to install and allows precise adjustment for perfect door alignment."
    }
  ]
},
  {
  code: "7585",
  name: "PUSH OPEN BLACK HINGES",
  category: "cabinet-hinges",

  mainImage: mainImage5,
  thumbnails: [thumb11, thumb12],

  // ✅ PRICE
  price: "₹174",
  oldPrice: "₹229",
  sku: "7585",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=Push Open Black Hinges Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION (IMPROVED)
  short:
    "The Push Open Black Hinge is a modern solution for handle-less cabinet designs, offering smooth push-to-open functionality. Designed with a built-in hydraulic soft-close mechanism, it ensures silent, controlled closing while protecting cabinets from damage. Made from high-quality mild steel with a durable black coating, it provides excellent strength, stability, and corrosion resistance. Ideal for modular kitchens, wardrobes, and contemporary furniture, this hinge combines sleek aesthetics with reliable everyday performance.",

  // ✅ FEATURES (REFINED)
  features: [
    "Push-to-open functionality for handle-less cabinets",
    "Hydraulic soft-close for smooth and silent closing",
    "Durable mild steel construction for long-lasting use",
    "Black-coated finish for modern premium look",
    "Stable and secure installation",
    "Perfect for modular kitchens and wardrobes",
    "Available Codes: 7585, 7586, 7587"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Mild Steel with Black Coating" },
    { label: "Mechanism", value: "Push Open + Soft Close Hydraulic" },
    { label: "Finish", value: "Black" },
    { label: "Mounting", value: "Standard Fixing" },
    { label: "Usage", value: "Handle-less Cabinets / Wardrobes / Modular Kitchen" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Push Open Black Hinge",
      code: "7585",
      size: "0°",
      finish: "Black"
    },
    {
      item: "Push Open Black Hinge",
      code: "7786",
      size: "8°",
      finish: "Black"
    },
    {
      item: "Push Open Black Hinge",
      code: "7587",
      size: "15°",
      finish: "Black"
    }
  ],

  // ✅ FAQ (REFINED)
  faq: [
    {
      question: "What are Push Open Black Hinges?",
      answer:
        "These hinges allow cabinet doors to open with a simple push, eliminating the need for handles and giving a clean, modern look."
    },
    {
      question: "How does the push open mechanism work?",
      answer:
        "It uses a spring-loaded system that releases the door when pressed, allowing it to open smoothly."
    },
    {
      question: "Where can these hinges be used?",
      answer:
        "They are ideal for modular kitchens, wardrobes, cabinets, and modern furniture with handle-less designs."
    },
    {
      question: "Do these hinges support soft closing?",
      answer:
        "Yes, they include a hydraulic soft-close mechanism for smooth and silent door closing."
    },
    {
      question: "Is the black finish durable?",
      answer:
        "Yes, the black coating provides corrosion resistance, durability, and a stylish modern appearance."
    }
  ]
},

{
  code: "7518",
  name: "SS SHORT ARM HYDRAULIC HINGES",
  category: "cabinet-hinges",

  mainImage: mainImg6,
  thumbnails: [thumb13, thumb14],

  // ✅ PRICE
  price: "₹130",
  oldPrice: "₹469",
  sku: "7518",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/9650100908?text=SS Short Arm Hydraulic Hinges Inquiry",

  // ✅ VIDEO (⚠️ if error aaye to change karna padega)
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  // ✅ DESCRIPTION (IMPROVED)
  short:
    "The SS Short Arm Hydraulic Hinge is a premium stainless steel hinge designed for compact cabinet spaces. Its short arm structure makes it ideal for tight installations while maintaining precise door alignment. Equipped with a hydraulic soft-close mechanism, it ensures smooth, silent, and controlled closing, protecting cabinets from damage. Made from high-quality stainless steel, it offers excellent durability, corrosion resistance, and long-lasting performance, making it perfect for modular kitchens, wardrobes, and modern furniture.",

  // ✅ FEATURES (REFINED)
  features: [
    "Hydraulic soft-close for smooth and silent closing",
    "Short arm design for compact cabinet spaces",
    "High-quality stainless steel construction",
    "Corrosion-resistant and long-lasting durability",
    "Stable and precise door alignment",
    "Easy installation and maintenance",
    "Available Code: 7518"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Stainless Steel (SS)" },
    { label: "Design", value: "Short Arm" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Finish", value: "SS" },
    { label: "Usage", value: "Cabinets / Wardrobes / Modular Kitchen" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SS Short Arm Hydraulic Hinge",
      code: "7518",
      size: "",
      finish: "SS"
    },
    
  ],

  // ✅ FAQ (REFINED)
  faq: [
    {
      question: "What are SS Short Arm Hydraulic Hinges?",
      answer:
        "They are stainless steel hinges with a short arm design and hydraulic soft-close mechanism for smooth and silent door operation."
    },
    {
      question: "Where are these hinges used?",
      answer:
        "They are ideal for modular kitchens, wardrobes, and compact cabinets where space-saving hinge design is required."
    },
    {
      question: "Do they support soft closing?",
      answer:
        "Yes, they include a hydraulic system for smooth, controlled, and silent closing."
    },
    {
      question: "Are they durable?",
      answer:
        "Yes, stainless steel construction ensures high durability, corrosion resistance, and long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, these hinges are easy to install and allow proper door alignment."
    }
  ]
},

{
  code: "7512",
  name: "3D Aluminium Profile Hinges",
  category: "cabinet-hinges",

  short:
    "The 3D Aluminium Profile Hinge is a premium hinge designed for aluminium and modular cabinets, offering three-dimensional (3D) adjustment for perfect door alignment. Its robust construction ensures smooth operation, long-lasting durability, and resistance to daily wear and tear. Ideal for modern kitchens, offices, or commercial furniture, this hinge allows precise positioning in height, depth, and side adjustment. Lightweight yet strong, it enhances functionality while maintaining a sleek, professional look. Its corrosion-resistant finish ensures reliability and a polished appearance for years to come.",

  features: [
    "3D adjustment (height, depth, side)",
    "Smooth & silent operation",
    "Strong aluminium body",
    "Corrosion-resistant finish",
    "Easy installation",
    "Ideal for modular & aluminium cabinets",
    "Available Codes: 7512, 7513, 7514"
  ],

  /* ✅ PRICE */
  price: "₹221",
  oldPrice: "₹300",

  /* ✅ SKU + STOCK */
  sku: "7512",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg7,
  thumbnails: [thumb15, thumb16],

  /* ✅ VIDEO (IMPORTANT) */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%203D%20Aluminium%20Profile%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Aluminium" },
    { label: "Adjustment", value: "3D (Height, Depth, Side)" },
    { label: "Finish", value: "Corrosion Resistant" },
    { label: "Application", value: "Modular Kitchen / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "3D Aluminium Profile Hinges ", code: "7512", size: "0°", finish: "Aluminium" },
    { item: "3D Aluminium Profile Hinges", code: "7513", size: "8°", finish: "Aluminium" },
    { item: "3D Aluminium Profile Hinges", code: "7514", size: "15°", finish: "Aluminium" }
  ],
  

  /* ✅ FAQ */
  faq: [
    {
      question: "What are 3D Aluminium Profile Hinges?",
      answer: "These hinges are designed for aluminium frame cabinet doors with smooth movement and precision adjustment."
    },
    {
      question: "What does 3D adjustment mean?",
      answer: "It allows alignment in height, depth, and side-to-side directions."
    },
    {
      question: "Where are these hinges used?",
      answer: "Used in modular kitchens, wardrobes, and aluminium cabinets."
    },
    {
      question: "Are these hinges durable?",
      answer: "Yes, they are corrosion-resistant and long-lasting."
    }
  ]
},
   {
  code: "7517",
  name: "MS Short Arm Hydraulic Hinge",
  category: "cabinet-hinges",

  short:
    "The MS Short Arm Hydraulic Hinge is a compact and durable hinge designed for cabinets and modular furniture. Built with high-quality mild steel, it features a soft-close hydraulic mechanism that ensures smooth and silent door operation. Its short arm design makes it ideal for tight spaces while maintaining strong support and stability. Perfect for kitchens, wardrobes, and office furniture, this hinge offers long-lasting performance with a sleek and functional design.",

  features: [
    "High-quality mild steel construction",
    "Soft-close hydraulic mechanism",
    "Smooth & silent operation",
    "Compact short-arm design",
    "Strong and durable",
    "Easy installation",
    "Code: 7517"
  ],

  /* ✅ PRICE */
  price: "₹118",
  oldPrice: "₹260",

  /* ✅ SKU + STOCK */
  sku: "7517",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg8,
  thumbnails: [thumb17, thumb18],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
   catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%20MS%20Short%20Arm%20Hydraulic%20Hinge",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Mild Steel (MS)" },
    { label: "Type", value: "Short Arm Hydraulic" },
    { label: "Closing Type", value: "Soft Close" },
    { label: "Application", value: "Cabinets / Modular Kitchen" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "MS Short Arm Hydraulic Hinge", code: "7517", size: "", finish: "MS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is an MS Short Arm Hydraulic Hinge?",
      answer:
        "It is a mild steel hinge with a compact short-arm design and built-in soft-close hydraulic mechanism for smooth operation."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for modular kitchens, wardrobes, cabinets, and furniture doors."
    },
    {
      question: "Does it support soft closing?",
      answer:
        "Yes, it ensures smooth and noise-free closing with its hydraulic system."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong mild steel and offers long-lasting performance."
    }
  ]
},


  {
  code: "7071",
  name: "3D THICK DOOR CABINET HINGES",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "3D Thick Door Cabinet Hinges heavy aur thick cabinet doors ke liye specially designed hain. Inme 3-way adjustment (height, depth, side) milta hai jisse door perfectly align hota hai. Strong build, smooth opening aur long life performance ke saath yeh modern modular kitchens aur wardrobes ke liye ideal choice hai.",

  /* ✅ FEATURES */
  features: [
    "3D adjustment (height, depth, side)",
    "Heavy & thick doors ke liye suitable",
    "Smooth & silent closing",
    "Strong & durable construction",
    "Stable door support",
    "Easy installation",
    "Available Codes: 7071, 7072, 7073"
  ],

  /* ✅ PRICE */
  price: "₹221",
  oldPrice: "₹320",

  /* ✅ SKU + STOCK */
  sku: "7071",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg9,
  thumbnails: [thumb19, thumb20],

  /* ✅ VIDEO (AS YOU PROVIDED) */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%203D%20Thick%20Door%20Cabinet%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "High Strength Steel" },
    { label: "Adjustment", value: "3D (Height, Depth, Side)" },
    { label: "Door Type", value: "Thick / Heavy Doors" },
    { label: "Application", value: "Kitchen / Wardrobe / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "3D Thick Door Hinge", code: "7071", size: "0°", finish: "MS" },
    { item: "3D Thick Door Hinge", code: "7072", size: "8°", finish: "MS" },
    { item: "3D Thick Door Hinge", code: "7073", size: "15°", finish: "MS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are 3D Thick Door Cabinet Hinges?",
      answer:
        "These hinges are specially designed for thick and heavy cabinet doors with strong support and precise 3D adjustment."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "It allows door alignment in three directions: height, depth, and side-to-side for perfect fitting."
    },
    {
      question: "Where can these hinges be used?",
      answer:
        "They are ideal for modular kitchens, wardrobes, and heavy cabinet doors."
    },
    {
      question: "Are these hinges durable?",
      answer:
        "Yes, they are built with strong materials ensuring long-lasting and stable performance."
    }
  ]
},

 {
  code: "7581",
  name: "90° BLIND CORNER HINGES",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "90° Blind Corner Hinges specially corner cabinets ke liye design kiye gaye hain jahan space limited hota hai. Yeh hinges door ko smooth tarike se 90° tak open karte hain bina adjacent cabinet ya wall se takraye. Concealed design hone ki wajah se yeh closed position me bilkul hidden rehte hain, jo modern kitchen aur wardrobe ko clean aur premium look dete hain.",

  /* ✅ FEATURES */
  features: [
    "90° controlled opening",
    "Ideal for blind corner cabinets",
    "Smooth & silent movement",
    "Concealed design for clean look",
    "Strong & durable material",
    "Easy installation & adjustment",
    "Available Codes: 7581, 7054"
  ],

  /* ✅ PRICE */
  price: "₹224",
  oldPrice: "₹290",

  /* ✅ SKU + STOCK */
  sku: "7581",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg10,
  thumbnails: [thumb21, thumb22],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%2090%20Degree%20Blind%20Corner%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "High Quality Steel" },
    { label: "Opening Angle", value: "90°" },
    { label: "Type", value: "Blind Corner Hinge" },
    { label: "Application", value: "Corner Cabinets / Kitchen / Wardrobe" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Blind Corner Hinge", code: "7581", size: "3D°", finish: "" },
    { item: "Blind Corner Hinge", code: "7054", size: "NORMAL", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are 90° Blind Corner Hinges?",
      answer:
        "These hinges are designed for corner cabinets where space is limited, allowing smooth 90° opening."
    },
    {
      question: "Where are these hinges used?",
      answer:
        "They are mainly used in modular kitchens, wardrobes, and corner cabinet units."
    },
    {
      question: "What is the benefit of 90° opening?",
      answer:
        "It prevents doors from hitting walls or nearby cabinets and ensures controlled movement."
    },
    {
      question: "Are these hinges durable?",
      answer:
        "Yes, they are made from strong materials ensuring long-lasting performance."
    }
  ]
},


  {
  code: "7582",
  name: "FIVE HOLE MS 3D HYDRAULIC HINGE",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "Five Hole MS 3D Hydraulic Hinges strong aur heavy cabinet doors ke liye design kiye gaye hain. High-quality mild steel se bane ye hinges hydraulic soft-close mechanism ke saath aate hain jo smooth aur silent closing ensure karta hai. 3D adjustment feature ke through aap door ko height, depth aur side me perfectly align kar sakte hain. Five-hole mounting design extra stability aur long-lasting performance deta hai, jo modular kitchens aur wardrobes ke liye ideal hai.",

  /* ✅ FEATURES */
  features: [
    "High-quality mild steel (MS) body",
    "Hydraulic soft-close mechanism",
    "3D adjustment (height, depth, side)",
    "Five-hole mounting for extra stability",
    "Smooth & silent operation",
    "Durable & long-lasting performance",
    "Ideal for heavy cabinet doors"
  ],

  /* ✅ PRICE */
  price: "₹230",
  oldPrice: "₹310",

  /* ✅ SKU + STOCK */
  sku: "7582",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg11,
  thumbnails: [thumb23, thumb24],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Five%20Hole%20MS%203D%20Hydraulic%20Hinge",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Mild Steel (MS)" },
    { label: "Adjustment", value: "3D (Height, Depth, Side)" },
    { label: "Closing Type", value: "Hydraulic Soft Close" },
    { label: "Mounting", value: "Five Hole Fixing" },
    { label: "Application", value: "Kitchen / Wardrobe / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Five Hole MS 3D Hydraulic Hinge", code: "7575", size: "0°", finish: "MS" },
    { item: "Five Hole MS 3D Hydraulic Hinge", code: "7576", size: "8°", finish: "MS" },
     { item: "Five Hole MS 3D Hydraulic Hinge", code: "7577", size: "15°", finish: "MS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Five Hole MS 3D Hydraulic Hinge?",
      answer:
        "It is a mild steel hinge with five fixing holes and a hydraulic soft-close system for smooth door movement."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "It allows door alignment in height, depth, and side directions for perfect fitting."
    },
    {
      question: "Where is this hinge used?",
      answer:
        "It is ideal for modular kitchens, wardrobes, and heavy cabinet doors."
    },
    {
      question: "What is the advantage of five hole mounting?",
      answer:
        "It provides extra strength, better grip, and long-lasting stability."
    }
  ]
},



  {
  code: "7583",
  name: "SMALL ANGLE 4D HYDRAULIC HINGE",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "Small Angle 4D Hydraulic Hinge compact cabinet spaces ke liye specially design kiya gaya hai jahan limited opening required hoti hai. Yeh hinge advanced hydraulic soft-close mechanism ke saath smooth aur silent door movement deta hai. 4D adjustment feature se aap door ko height, depth, side aur angle me perfectly align kar sakte hain. Strong aur rust-resistant build ke saath yeh modular kitchens aur wardrobes ke liye ek perfect solution hai.",

  /* ✅ FEATURES */
  features: [
    "Small angle opening (tight spaces ke liye ideal)",
    "4D adjustment (height, depth, side, angle)",
    "Hydraulic soft-close (silent closing)",
    "Smooth & controlled door movement",
    "Strong, durable & rust-resistant body",
    "Easy installation",
    "Code: 7583"
  ],

  /* ✅ PRICE */
  price: "₹296",
  oldPrice: "₹320",

  /* ✅ SKU + STOCK */
  sku: "7583",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg12,
  thumbnails: [thumb25, thumb26],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Small%20Angle%204D%20Hydraulic%20Hinge",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "High Quality Steel" },
    { label: "Adjustment", value: "4D (Height, Depth, Side, Angle)" },
    { label: "Opening Type", value: "Small Angle" },
    { label: "Closing Type", value: "Hydraulic Soft Close" },
    { label: "Application", value: "Kitchen / Wardrobe / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "4D Hydraulic Hinge", code: "7582", size: "0°", finish: "Nickel" },
     { item: "4D Hydraulic Hinge", code: "7583", size: "8°", finish: "Nickel" },
      { item: "4D Hydraulic Hinge", code: "7588", size: "15°", finish: "Nickel" },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Small Angle 4D Hydraulic Hinge?",
      answer:
        "It is a hinge designed for limited opening spaces with smooth hydraulic soft-closing."
    },
    {
      question: "What does 4D adjustment mean?",
      answer:
        "It allows adjustment in height, depth, side, and angle for perfect door alignment."
    },
    {
      question: "Where is this hinge used?",
      answer:
        "Used in modular kitchens, wardrobes, and compact cabinet spaces."
    },
    {
      question: "What is the benefit of small angle opening?",
      answer:
        "It prevents doors from hitting nearby walls or cabinets and ensures controlled movement."
    }
  ]
},


  {
  code: "7560",
  name: "FULL SS 3D HYDRAULIC HINGES",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "Full SS 3D Hydraulic Hinges high-quality stainless steel se bane hote hain jo rust-free, durable aur long-lasting performance dete hain. Inme hydraulic soft-close mechanism hota hai jo door ko smooth aur silent tareeke se band karta hai. 3D adjustment system ke through door ko height, depth aur side me easily align kiya ja sakta hai. Yeh hinges modular kitchens, wardrobes aur premium cabinets ke liye perfect choice hain.",

  /* ✅ FEATURES */
  features: [
    "Full stainless steel body (rust-resistant)",
    "Hydraulic soft-close (silent closing)",
    "3D adjustment (height, depth, side)",
    "Smooth & controlled movement",
    "Strong & long-lasting performance",
    "Ideal for kitchen & wardrobe cabinets",
    "Available Codes: 7560, 7561, 7562"
  ],

  /* ✅ PRICE */
  price: "₹301",
  oldPrice: "₹340",

  /* ✅ SKU + STOCK */
  sku: "7560",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg13,
  thumbnails: [thumb27, thumb28],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/Qje9alnIonU",

  /* ✅ BUTTON LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Full%20SS%203D%20Hydraulic%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Full Stainless Steel" },
    { label: "Adjustment", value: "3D (Height, Depth, Side)" },
    { label: "Closing Type", value: "Hydraulic Soft Close" },
    { label: "Crank Type", value: "0°, 8°, 15°" },
    { label: "Application", value: "Kitchen / Wardrobe / Cabinets" }
  ],

  /* ✅ SPEC TABLE (SIZE UPDATED) */
  specTable: [
    { item: "Full SS 3D Hydraulic Hinge", code: "7560", size: "0°", finish: "SS" },
    { item: "Full SS 3D Hydraulic Hinge", code: "7561", size: "8°", finish: "SS" },
    { item: "Full SS 3D Hydraulic Hinge", code: "7562", size: "15°", finish: "SS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are Full SS 3D Hydraulic Hinges?",
      answer:
        "These are stainless steel hinges with a hydraulic soft-close mechanism for smooth and silent door operation."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "It allows door alignment in height, depth, and side directions for perfect fitting."
    },
    {
      question: "Where are these hinges used?",
      answer:
        "They are used in modular kitchens, wardrobes, and premium cabinets."
    },
    {
      question: "Are these hinges rust-proof?",
      answer:
        "Yes, being full stainless steel, they are highly resistant to rust and corrosion."
    }
  ]
} ,

   {
  code: "7368",
  name: "SUS 304 2D HYDRAULIC HINGE",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "SUS 304 2D Hydraulic Hinge premium stainless steel se bana hota hai jo excellent rust resistance aur long-lasting performance deta hai. Isme hydraulic soft-close mechanism hota hai jo door ko smooth aur silent tareeke se band karta hai. 2D adjustment feature ke through door ko easily align kiya ja sakta hai, jo modular kitchens, bathrooms aur wardrobes ke liye perfect choice banata hai.",

  /* ✅ FEATURES */
  features: [
    "SUS 304 stainless steel (rust-proof)",
    "2D adjustment (height & side)",
    "Hydraulic soft-close (silent closing)",
    "Smooth & controlled door movement",
    "Moisture-resistant & durable design",
    "Long-lasting performance",
    "Available Codes: 7368, 7367, 7369"
  ],

  /* ✅ PRICE */
  price: "₹288",
  oldPrice: "₹330",

  /* ✅ SKU + STOCK */
  sku: "7368",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg14,
  thumbnails: [thumb29, thumb30],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20SUS%20304%202D%20Hydraulic%20Hinge",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "SUS 304 Stainless Steel" },
    { label: "Adjustment", value: "2D (Height, Side)" },
    { label: "Closing Type", value: "Hydraulic Soft Close" },
    { label: "Crank Type", value: "0°, 8°, 15°" },
    { label: "Application", value: "Kitchen / Bathroom / Wardrobe" }
  ],

  /* ✅ SPEC TABLE (SIZE FIXED) */
  specTable: [
    { item: "SUS 304 Hydraulic Hinge", code: "7367", size: "0°", finish: "SS" },
    { item: "SUS 304 Hydraulic Hinge", code: "7368", size: "8°", finish: "SS" },
    { item: "SUS 304 Hydraulic Hinge", code: "7369", size: "15°", finish: "SS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a SUS 304 2D Hydraulic Hinge?",
      answer:
        "It is a stainless steel hinge with hydraulic soft-close for smooth and silent door operation."
    },
    {
      question: "What does 2D adjustment mean?",
      answer:
        "It allows adjustment in height and side direction for proper door alignment."
    },
    {
      question: "Where is this hinge used?",
      answer:
        "It is used in modular kitchens, wardrobes, and bathroom cabinets."
    },
    {
      question: "Is SUS 304 rust-proof?",
      answer:
        "Yes, SUS 304 stainless steel offers excellent resistance to rust and moisture."
    }
  ]
},


  {
  code: "7755",
  name: "4 INCH NON HYDRAULIC FROG HINGES",
  category: "cabinet-hinges",

  /* ✅ SHORT DESCRIPTION */
  short:
    "4 Inch Non-Hydraulic Frog Hinges ek strong aur reliable hinge solution hai jo cabinet doors ke liye smooth opening provide karta hai. Isme hydraulic system nahi hota, isliye yeh simple, maintenance-free aur cost-effective option hai. Yeh hinges wooden cabinets, wardrobes aur furniture doors ke liye perfect hain jahan durability aur strength important hoti hai.",

  /* ✅ FEATURES */
  features: [
    "Heavy duty 4 inch frog hinge",
    "Non-hydraulic (manual closing)",
    "Strong grip for wooden doors",
    "Smooth opening mechanism",
    "Durable & long-lasting design",
    "Easy installation",
    "Code: 7755"
  ],

  /* ✅ PRICE */
  price: "₹101",
  oldPrice: "₹250",

  /* ✅ SKU + STOCK */
  sku: "7755",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg15,
  thumbnails: [thumb31, thumb32],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%204%20Inch%20Non%20Hydraulic%20Frog%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Steel" },
    { label: "Type", value: "Non Hydraulic Frog Hinge" },
    { label: "Size", value: "4 Inch" },
    { label: "Closing Type", value: "Manual Closing" },
    { label: "Application", value: "Wooden Cabinets / Wardrobes" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Frog Hinge", code: "7755", size: "4 Inch", finish: "Nickel" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are 4 Inch Non Hydraulic Frog Hinges?",
      answer:
        "These are traditional cabinet hinges designed for wooden doors with strong support and simple operation."
    },
    {
      question: "Where are frog hinges used?",
      answer:
        "They are used in wardrobes, cabinets, and wooden furniture doors."
    },
    {
      question: "Do these hinges have soft closing?",
      answer:
        "No, they use a manual closing mechanism without hydraulic soft-close."
    },
    {
      question: "Are these hinges durable?",
      answer:
        "Yes, they are strong, reliable, and long-lasting for daily use."
    }
  ]
},

  {
  code: "7756",
  name: "3 INCH NON HYDRAULIC FROG HINGES",
  category: "cabinet-hinges",

  short:
    "The 3 Inch Non-Hydraulic Frog Hinge is a compact and durable cabinet hinge designed for small doors. It operates on a simple non-hydraulic mechanism, ensuring smooth opening and long-lasting performance. This hinge is an economical and reliable choice for modular kitchens, wardrobes, and furniture where compact size and strong grip are required.",

  features: [
    "Compact 3 inch frog hinge design",
    "Non-hydraulic simple & durable mechanism",
    "Smooth opening performance",
    "Strong grip for small cabinet doors",
    "Easy installation",
    "Long-lasting durability",
    "Code: 7756"
  ],

  /* ✅ PRICE */
  price: "₹81",
  oldPrice: "₹140",

  /* ✅ SKU + STOCK */
  sku: "7754",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg16,
  thumbnails: [thumb33, thumb34],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%203%20Inch%20Non%20Hydraulic%20Frog%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Mild Steel" },
    { label: "Type", value: "Non Hydraulic" },
    { label: "Size", value: "3 Inch" },
    { label: "Application", value: "Cabinets / Wardrobes / Furniture" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "3 Inch Frog Hinges", code: "7754", size: "3 Inch", finish: "Steel" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are 3 Inch Non Hydraulic Frog Hinges?",
      answer:
        "3 Inch Non Hydraulic Frog Hinges are compact cabinet hinges designed for wooden doors, offering strong support and smooth opening without a soft-close mechanism."
    },
    {
      question: "Where are 3 inch frog hinges used?",
      answer:
        "They are commonly used in small cabinets, cupboards, wardrobes, and furniture doors where compact hinge size is required."
    },
    {
      question: "Do these hinges support soft closing?",
      answer:
        "No, these are non-hydraulic hinges and work with a manual closing system."
    },
    {
      question: "What are the advantages of these hinges?",
      answer:
        "They provide strong grip, easy installation, reliable performance, and long-lasting durability for daily use."
    }
  ]
},


  {
  code: "7753",
  name: "AIR HINGE TITANIUM",
  category: "cabinet-hinges",

  short:
    "Air Hinge Titanium is a premium soft-close hinge with a stylish titanium finish that enhances the look of modern cabinets. It features an advanced air-pressure hydraulic system for smooth, silent, and controlled door closing. Built with strong and corrosion-resistant material, it ensures durability and long-lasting performance. Ideal for modular kitchens, wardrobes, and furniture, it offers both functionality and a premium aesthetic.",

  features: [
    "Premium titanium finish for modern look",
    "Air-pressure soft close mechanism",
    "Smooth & silent door closing",
    "Strong and corrosion-resistant body",
    "Easy installation and adjustment",
    "Long-lasting durability",
    "Code: 7753"
  ],

  /* ✅ PRICE */
  price: "₹2470",
  oldPrice: "₹3000",

  /* ✅ SKU + STOCK */
  sku: "7753",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg17,
  thumbnails: [thumb35, thumb36],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/PGnOCOHQ4Ps",

  /* ✅ BUTTON LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%20Air%20Hinge%20Titanium",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal with Titanium Finish" },
    { label: "Type", value: "Air Pressure Hydraulic" },
    { label: "Closing", value: "Soft Close" },
    { label: "Application", value: "Modular Kitchen / Wardrobes / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Air Hinge Titanium", code: "7753", size: "", finish: "Titanium" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is an Air Hinge Titanium?",
      answer:
        "Air Hinge Titanium is a premium soft-close hinge with a titanium finish, designed for smooth and silent cabinet door movement."
    },
    {
      question: "Where can Air Hinge Titanium be used?",
      answer:
        "It is commonly used in modular kitchens, wardrobes, cabinets, and modern furniture."
    },
    {
      question: "What are the benefits of titanium finish?",
      answer:
        "Titanium finish provides a modern look, corrosion resistance, and long-lasting durability."
    },
    {
      question: "Is it suitable for daily use?",
      answer:
        "Yes, it is designed for smooth, silent, and reliable daily cabinet operation."
    }
  ]
},

   {
  code: "7509",
  name: "GLASS DOOR HINGES",
  category: "cabinet-hinges",

  short:
    "Glass Door Hinges are specially designed for glass cabinets and display units, providing a strong and secure grip without damaging the glass surface. These hinges ensure smooth, stable, and silent door movement while maintaining a sleek and modern appearance. Built with durable and corrosion-resistant materials, they are ideal for modular kitchens, showcases, wardrobes, and commercial display furniture.",

  features: [
    "Designed specifically for glass doors",
    "Strong grip without damaging glass",
    "Smooth & stable door movement",
    "Rust-resistant and durable build",
    "Easy installation",
    "Modern sleek finish",
    "Code: 7509, 7510, 7511"
  ],

  /* ✅ PRICE */
  price: "₹180",
  oldPrice: "₹220",

  /* ✅ SKU + STOCK */
  sku: "7509",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg18,
  thumbnails: [thumb37, thumb38],

  /* ✅ VIDEO */
  video: "https://www.instagram.com/reel/DUAewZjj3u4/embed",

  /* ✅ BUTTON LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%20Glass%20Door%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Glass Compatible" },
    { label: "Application", value: "Glass Cabinets / Showcases" },
    { label: "Finish", value: "Corrosion Resistant" },
    { label: "Installation", value: "Clamp / Screw Type" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Glass Door Hinges", code: "7509", size: "0°", finish: "Chrome" },
    { item: "Glass Door Hinges", code: "7510", size: "8°", finish: "Matte" },
    { item: "Glass Door Hinges", code: "7511", size: "15°", finish: "Steel" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are Glass Door Hinges?",
      answer:
        "Glass Door Hinges are specially designed to support and secure glass cabinet doors with smooth opening and closing."
    },
    {
      question: "Where are glass door hinges used?",
      answer:
        "They are used in glass cabinets, display units, kitchen cupboards, wardrobes, and modern furniture."
    },
    {
      question: "Are these hinges safe for glass?",
      answer:
        "Yes, they provide a strong grip without damaging the glass surface."
    },
    {
      question: "What are the advantages?",
      answer:
        "They offer smooth movement, secure holding, modern design, and long-lasting durability."
    }
  ]
},

  
   {
  code: "7051",
  name: "SS 2D HYDRAULIC HINGES",
  category: "cabinet-hinges",

  short:
    "SS 2D Hydraulic Hinges are made from high-quality stainless steel, offering excellent strength, rust resistance, and long-lasting durability. These hinges come with a built-in hydraulic soft-close mechanism that ensures smooth, silent, and controlled door closing, preventing slamming. The 2D adjustment system allows precise alignment in vertical and horizontal directions, making them ideal for modular kitchens, wardrobes, and cabinet furniture.",

  features: [
    "Stainless steel body for rust resistance",
    "2D adjustment (vertical & horizontal)",
    "Hydraulic soft-close mechanism",
    "Smooth & silent door closing",
    "Durable and long-lasting performance",
    "Easy installation",
    "Code: 7051, 7052, 7053",
    "Crank: 0°, 8°, 15°"
  ],

  /* ✅ PRICE */
  price: "₹165",
  oldPrice: "₹230",

  /* ✅ SKU + STOCK */
  sku: "7051",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg19,
  thumbnails: [thumb39, thumb40],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/zrGJsKTjEdQ",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%20SS%202D%20Hydraulic%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Adjustment", value: "2D (Vertical & Horizontal)" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Application", value: "Modular Kitchen / Wardrobes / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "SS 2D Hydraulic Hinges", code: "7051", size: "0°", finish: "SS" },
    { item: "SS 2D Hydraulic Hinges", code: "7052", size: "8°", finish: "SS" },
    { item: "SS 2D Hydraulic Hinges", code: "7053", size: "15°", finish: "SS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are SS 2D Hydraulic Hinges?",
      answer:
        "These are stainless steel cabinet hinges with a hydraulic soft-close mechanism for smooth and silent door closing."
    },
    {
      question: "What does 2D adjustment mean?",
      answer:
        "2D adjustment allows alignment in vertical (up/down) and horizontal (left/right) directions."
    },
    {
      question: "Where are these hinges used?",
      answer:
        "They are used in modular kitchens, wardrobes, cabinets, and furniture doors."
    },
    {
      question: "Are these hinges rust resistant?",
      answer:
        "Yes, they are made from stainless steel which provides excellent rust resistance and durability."
    }
  ]
},
  {
  code: "7578",
  name: "FIVE HOLE BLACK 3D HYDRAULIC HINGES",
  category: "cabinet-hinges",

  short:
    "Five Hole Black 3D Hydraulic Hinges are designed for strong support, precise door alignment, and smooth performance. The advanced 3D adjustment system allows accurate positioning in height, depth, and side directions for a perfect cabinet fit. Its built-in hydraulic soft-close mechanism ensures silent and controlled door closing, preventing slamming. The premium black finish enhances the modern look of modular kitchens, wardrobes, and furniture while providing durability and long-lasting performance.",

  features: [
    "3D adjustment (height, depth, side)",
    "Hydraulic soft-close mechanism",
    "Smooth & silent door closing",
    "Five-hole plate for extra stability",
    "Strong and durable construction",
    "Modern premium black finish",
    "Easy installation and adjustment",
    "Code: 7578, 7579, 7580",
    "Crank: 0°, 8°, 15°"
  ],

  /* ✅ PRICE */
  price: "₹180",
  oldPrice: "₹270",

  /* ✅ SKU + STOCK */
  sku: "7578",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg20,
  thumbnails: [thumb41, thumb42],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%20Five%20Hole%20Black%203D%20Hydraulic%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Mild Steel with Black Finish" },
    { label: "Adjustment", value: "3D (Height, Depth, Side)" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Application", value: "Modular Kitchen / Wardrobes / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Black 3D Hydraulic Hinges", code: "7578", size: "0°", finish: "Black" },
    { item: "Black 3D Hydraulic Hinges", code: "7579", size: "8°", finish: "Black" },
    { item: "Black 3D Hydraulic Hinges", code: "7580", size: "15°", finish: "Black" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are Five Hole Black 3D Hydraulic Hinges?",
      answer:
        "These are cabinet hinges with a black finish and hydraulic soft-close mechanism, designed for smooth and silent door operation."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "3D adjustment allows alignment in height, depth, and side directions for perfect door fitting."
    },
    {
      question: "Where are these hinges used?",
      answer:
        "They are used in modular kitchens, wardrobes, cabinets, and modern furniture."
    },
    {
      question: "What are the advantages of this hinge?",
      answer:
        "They offer strong support, smooth soft-close operation, precise adjustment, and a stylish modern black finish."
    }
  ]
},
 

  {
  code: "7566",
  name: "3D SS THICK DOOR CABINET HINGES",
  category: "cabinet-hinges",

  short:
    "3D SS Thick Door Cabinet Hinges are specially designed for heavy and thick cabinet doors, offering strong support and smooth performance. Made from high-quality stainless steel, these hinges provide excellent durability, rust resistance, and long-lasting reliability. The advanced 3D adjustment system allows precise alignment in height, depth, and side directions for a perfect door fit. Equipped with a hydraulic soft-close mechanism, they ensure silent and controlled door closing. Ideal for modular kitchens, wardrobes, and heavy furniture, these hinges combine strength, precision, and modern design.",

  features: [
    "3D adjustment (height, depth, side)",
    "Hydraulic soft-close mechanism",
    "Smooth & silent door closing",
    "Suitable for thick & heavy doors",
    "Strong stainless steel construction",
    "Rust-resistant and durable finish",
    "Easy installation and adjustment",
    "Code: 7566, 7567, 7568",
    "Crank: 0°, 8°, 15°"
  ],

  /* ✅ PRICE */
  price: "₹210",
  oldPrice: "₹290",

  /* ✅ SKU + STOCK */
  sku: "7566",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg21,
  thumbnails: [thumb43, thumb44],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=I%20am%20interested%20in%203D%20SS%20Thick%20Door%20Cabinet%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Adjustment", value: "3D (Height, Depth, Side)" },
    { label: "Closing Type", value: "Soft Close Hydraulic" },
    { label: "Application", value: "Thick Cabinet Doors / Modular Kitchen / Wardrobes" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "3D SS Thick Door Hinges", code: "7566", size: "0°", finish: "SS" },
    { item: "3D SS Thick Door Hinges", code: "7567", size: "8°", finish: "SS" },
    { item: "3D SS Thick Door Hinges", code: "7568", size: "15°", finish: "SS" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are 3D SS Thick Door Cabinet Hinges?",
      answer:
        "These are stainless steel hinges designed for thick and heavy cabinet doors with strong support and smooth movement."
    },
    {
      question: "What does 3D adjustment mean?",
      answer:
        "3D adjustment allows alignment in height, depth, and side directions for accurate door fitting."
    },
    {
      question: "Where are these hinges used?",
      answer:
        "They are used in modular kitchens, wardrobes, and heavy cabinet furniture."
    },
    {
      question: "What are the benefits?",
      answer:
        "They offer high strength, rust resistance, smooth soft-close operation, and long-lasting durability."
    }
  ]
},
 

 {
  code: "7567",
  name: "SOFT MOVEMENT BUTT HINGES",
  category: "cabinet-hinges",

  short:
    "Soft Movement Butt Hinges are designed to provide smooth and controlled door operation with enhanced durability. Made from high-quality stainless steel or premium metal, these hinges ensure long-lasting performance and resistance to rust. The soft movement mechanism reduces noise and prevents sudden door slamming, offering a comfortable and silent experience. Ideal for wooden doors, cabinets, and furniture applications, they deliver strong support and stable alignment. Perfect for residential and commercial use, these hinges combine strength with smooth functionality.",

  features: [
    "Smooth and silent door movement",
    "Strong and durable metal construction",
    "Rust-resistant finish",
    "Prevents hard door slamming",
    "Suitable for wooden doors & cabinets",
    "Available Sizes: 3X12, 4X12, 5X12, 6X12, 5X14, 4X14, 3X16 , 3X1/2X3/4 , 3X3/4X3/4, 3X1/X1"
  ],

  /* ✅ PRICE */
  price: "₹152",
  oldPrice: "₹220",

  /* ✅ SKU + STOCK */
  sku: "7685",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg22,
  thumbnails: [thumb45, thumb46],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Soft%20Movement%20Butt%20Hinges",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel / Metal" },
    { label: "Type", value: "Butt Hinge" },
    { label: "Finish", value: "Rust Resistant" },
    { label: "Application", value: "Doors / Cabinets / Furniture" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Soft Movement Butt Hinges (SS WELDED)", code: "7685", size: "6x12", finish: "Steel" },
    { item: "Soft Movement Butt Hinges (SS WELDED)", code: "7686", size: "5x12", finish: "Steel" },
    { item: "Soft Movement Butt Hinges (SS WELDED)", code: "7687", size: "4x12", finish: "Steel" },
     { item: "Soft Movement Butt Hinges (SS WELDED)", code: "7688", size: "3x12", finish: "Steel" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What are Soft Movement Butt Hinges?",
      answer:
        "Soft Movement Butt Hinges are durable door hinges designed to provide smooth and stable opening and closing for cabinet and furniture doors."
    },
    {
      question: "Where are soft movement butt hinges commonly used?",
      answer:
        "They are widely used in wooden doors, cabinets, wardrobes, and furniture where reliable and smooth door movement is required."
    },
    {
      question: "What are the advantages of butt hinges?",
      answer:
        "Butt hinges offer strong door support, smooth operation, easy installation, and long-lasting durability for everyday door use."
    },
    {
      question: "Are soft movement butt hinges suitable for heavy doors?",
      answer:
        "Yes, these hinges are designed to provide stable performance and can support medium to heavy doors depending on the installation."
    }
  ]
},                                                                                     
  
  
];
